export default {
  // Common
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    export: 'Export',
    import: 'Import',
    upload: 'Upload',
    download: 'Download',
    submit: 'Submit',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    refresh: 'Refresh',
    loading: 'Loading...',
    success: 'Operation successful',
    error: 'Operation failed',
    warning: 'Warning',
    info: 'Information',
    index: 'Index',
    actions: 'Actions',
    total: 'Total {total} items'
  },
  
  // Login
  login: {
    title: 'User Login',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    logout: 'Logout',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    getUserInfoFailed: 'Failed to get user info',
    notLoggedIn: 'Not logged in...',
    systemTitle: 'Qinghe Environmental Technology · Hydrogen Generator Management System',
    welcomeTitle: 'Welcome - Hydrogen Generator Management System',
    usernameMinLength: 'Username must be at least 2 characters',
    passwordFormat: 'Invalid password format',
    verificationCode: 'Verification code error (case sensitive)'
  },
  
  // Admin Page
  admin: {
    title: 'Qinghe Environmental Technology - Admin Management',
    dashboard: 'Dashboard',
    menu: 'Menu',
    logout: 'Logout'
  },

  // Menu
  menu: {
    equipment: 'Equipment & Filter Library',
    equipmentLibrary: 'Device & Filter Library',
    filterRecord: 'Filter Replacement Record',
    version: 'Home Version Library',
    dataQuery: 'TCP Data Query',
    heartbeat: 'Heartbeat Data',
    singleUse: 'Single Use Data',
    bindStats: 'Binding Statistics',
    customer: 'Customer Management',
    agentCheck: 'Agent Review',
    agentProfit: 'Agent Profit Management',
    promotionRoute: 'Promotion Route Configuration',
    partyType: 'Party Type Management',
    mqttQuery: 'MQTT Data Query',
    statusQuery: 'Status Query',
    outputRecord: 'Output Record Query',
    debug: 'Device Debug Page',
    waterTotal: 'Total Water Output Query',
    adminAccount: 'Admin Account',
    deviceType: 'Device Type Management',
    defaultSettings: 'Default System Settings',
    flowConfig: 'Water Flow Personalization',
    waterConfig: 'Water Configuration',
    businessLog: 'Business Log',
    payment: 'Payment Management',
    order: 'Order Management',
    statistics: 'Data Statistics',
    waterPrice: 'Water Price Configuration',
    recharge: 'Recharge'
  },

  // Device Management Title
  device: {
    title: 'Device Management',
    equipmentId: 'Equipment ID',
    enterEquipmentId: 'Enter equipment ID',
    equipmentType: 'Equipment Type',
    status: 'Status',
    iotCard: 'IoT Card',
    relatedOrg: 'Related Organization',
    city: 'City',
    actions: 'Actions',
    addEquipment: 'Add Equipment & Filter',
    exportEquipment: 'Export Equipment',
    clearTestData: 'Clear Test Data',
    modifyCard: 'Modify Card',
    transferOrg: 'Transfer Organization',
    modifyStatus: 'Modify Status',
    modifyLocation: 'Modify Location',
    modifyType: 'Modify Type',
    rechargeWater: 'Recharge Water',
    rechargeRecord: 'Recharge Record',
    generateQR: 'Generate QR Code',
    allOrganizations: 'All Organizations',
    allTypes: 'All Types',
    allStatus: 'All Status',
    used: 'Used',
    unused: 'Unused',
    repairing: 'Repairing',
    repairCompleted: 'Repair Completed',
    offline: 'Offline',
    online: 'Online',
    homeDevice: '▣Home Device',
    sharedDevice: '▣Shared Device',
    homeFilter: '☍Home Filter',
    sharedFilter: '☍Shared Filter',
    unknown: 'Unknown',
    quantity: 'Quantity',
    generateDate: 'Generate Date',
    selectDate: 'Select Date',
    offlineDays: 'Offline Days ≥',
    offlineDaysPlaceholder: 'Days',
    organization: 'Organization',
    clearTestConfirm: 'Are you sure to clear all test data? This operation cannot be undone!',
    clearTestSuccess: 'Clear test data successfully',
    clearTestFailed: 'Failed to clear test data',
    
    // Equipment Type Management
    typeCode: 'Equipment Type Code',
    typeName: 'Equipment Type Name',
    typeCodePlaceholder: 'Please enter type code',
    typeNamePlaceholder: 'Please enter equipment type name',
    typeCodeRequired: 'Type code is required',
    typeNameRequired: 'Type name is required',
    addType: 'Add Type',
    editType: 'Edit Type',
    deleteConfirm: 'Are you sure to delete equipment type "{name}"?',
    deleteSuccess: 'Delete successfully',
    deleteFailed: 'Delete failed',
    saveSuccess: 'Save successfully',
    saveFailed: 'Save failed',
    getDataFailed: 'Failed to get data',
    selectOrganization: 'Please select organization',
    universal: 'Universal',
    defaultOutVol: 'Default Output Volume (Miner)',
    outVolRequired: 'Default output volume is required',
    changeRule: 'Filter Change Rule',
    filterAlgorithm: 'Filter Algorithm',
    byVolume: 'By Volume',
    byTime: 'By Time',
    none: 'None',
    ruleDescription: 'Filter change calculation rule:',
    volumeRule: '1: Calculate by volume (e.g., 1-4 filters, change every 40000L)',
    timeRule: '2: Calculate by time (e.g., 1 year, 60000L)',
    iotCardPlaceholder: 'Please enter IoT card number',
    filterQuantityPlaceholder: 'Please enter filter quantity',
    equipmentIdRequired: 'Please enter device ID',
    equipmentTypeRequired: 'Please select equipment type',
    statusRequired: 'Please select status',
    iotCardRequired: 'Please enter IoT card number',
    quantityRequired: 'Please enter quantity',
    quantityMustBeNumber: 'Quantity must be a number',
    quantityMustBePositive: 'Quantity must be greater than 0',
    addSuccess: 'Add successful',
    exportSuccess: 'Export successful',
    clearSuccess: 'Clear successful',
    modifySuccess: 'Modify successful',
    qrGenerateSuccess: 'QR code generated successfully',
    qrGenerateFailed: 'QR code generation failed'
  },

  // Organization Management
  org: {
    title: 'Organization Management',
    list: 'Organization List',
    add: 'Add Organization',
    edit: 'Edit Organization',
    delete: 'Delete Organization',
    name: 'Organization Name',
    code: 'Organization Code',
    type: 'Organization Type'
  },

  // System Settings Title
  setting: {
    title: 'System Settings',
    general: 'General Settings',
    security: 'Security Settings',
    notification: 'Notification Settings'
  },

  // Data Statistics
  card: {
    title: 'Water Card Management',
    list: 'Water Card List',
    add: 'Add Water Card',
    bind: 'Bind Water Card',
    unbind: 'Unbind Water Card',
    import: 'Import Water Card',
    export: 'Export Water Card',
    serialNo: 'Serial Number',
    cardNo: 'Card Number',
    status: 'Status'
  },
  
  // Data Statistics
  stats: {
    title: 'Data Statistics',
    tds: 'TDS Statistics',
    volume: 'Volume Statistics',
    usage: 'Usage Statistics'
  },
  
  // Footer
  footer: {
    copyright: '© 2023 - Qinghe Environmental Technology Co., Ltd. All Rights Reserved',
    icp: 'ICP Record: ',
    techSupport: '© Technical Support: Guangzhou Guanjun Hydrogen Technology Co., Ltd.'
  },
  
  // Error Messages
  error: {
    network: 'Network Error',
    server: 'Server Error',
    permission: 'Insufficient Permission',
    param: 'Parameter Error',
    notFound: 'Data Not Found',
    pageNotFound: 'Sorry, the page you visited does not exist'
  },
  
    
    // Filter record related
    filterRecord: {
      title: 'Device Filter Change Records',
      equipmentId: 'Equipment ID',
      enterEquipmentId: 'Please enter equipment ID',
      equipmentIdRequired: 'Equipment ID is required',
      filterId: 'Filter ID',
      filterNumber: 'Filter Number',
      number: '',
      filter: 'Filter',
      changeTime: 'Change Time',
      waterDetail: 'Water Detail',
      orderNumber: 'Order Number',
      bagNumber: 'Bag Number',
      waterPerBag: 'Water per Bag (ml)',
      actualWater: 'Actual Water Output (ml)',
      timeUsed: 'Time Used (sec)',
      completionTime: 'Completion Time'
    },

    // Version library related
    versionLibrary: {
      title: 'Version Library Management',
      versionNumber: 'Version Number',
      enterVersionNumber: 'Please enter version number',
      status: 'Status',
      allStatus: 'All Status',
      published: 'Published',
      unpublished: 'Unpublished',
      equipmentType: 'Equipment Type',
      allTypes: 'All Types',
      publishNewVersion: 'Publish New Version',
      fileName: 'File Name',
      md5Checksum: 'MD5 Checksum',
      updateLog: 'Update Log',
      authorizedCities: 'Authorized Cities',
      publishTime: 'Publish Time',
      download: 'Download',
      edit: 'Edit',
      delete: 'Delete',
      authorize: 'Authorize',
      editVersion: 'Edit Version',
      versionAuthorization: 'Version Authorization',
      uploadFile: 'Upload File',
      dragFileText: 'Click to upload, or drag file here',
      uploadTip: 'Support any format file, max 20MB',
      publish: 'Publish',
      unpublish: 'Unpublish',
      updateLogPlaceholder: 'Update log',
      versionNumberPlaceholder: 'Please enter version number, e.g.: 1.0.1',
      versionNumberRequired: 'Version number is required',
      equipmentTypeRequired: 'Please select equipment type',
      fileRequired: 'Please upload file',
      fileSizeLimit: 'File size cannot exceed 20MB',
      uploadSuccess: 'Upload successful',
      uploadFailed: 'Upload failed',
      deleteConfirm: 'Are you sure to delete? This action cannot be undone!',
      deleteSuccess: 'Delete successful',
      saveSuccess: 'Save successful',
      authorizedRegions: 'Authorized Regions',
      allRegions: 'All Regions',
      unknown: 'Unknown'
    },

    // Heartbeat data related
    heartbeat: {
      title: 'Heartbeat Data Query',
      equipmentId: 'Equipment ID',
      enterEquipmentId: 'Please enter equipment ID',
      equipmentIdRequired: 'Equipment ID is required',
      equipmentType: 'Equipment Type',
      allTypes: 'All Types',
      totalWaterVolume: 'Total Water Volume (ml)',
      errorCode: 'Error Code',
      statusCode: 'Status Code',
      boardCommunication: 'Board Communication',
      heaterCommunication: 'Heater Communication',
      reportTime: 'Report Time',
      view: 'View',
      detailTitle: 'Heartbeat Data Details',
      basicInfo: 'Basic Information',
      statusInfo: 'Status Information',
      digitalInput: 'Digital Input',
      digitalOutput: 'Digital Output',
      temperatureInfo: 'Temperature Information',
      tdsInfo: 'TDS Information',
      flowInfo: 'Flow Information',
      uiVersion: 'UI Version',
      mcuVersion: 'MCU Version',
      recentDispenseTime: 'Recent Dispense Time',
      recentCleanTime: 'Recent Clean Time',
      coolerTemperature: 'Cooler Temperature (℃)',
      boardTemperature: 'Board Temperature (℃)',
      heaterTemperature: 'Heater Temperature (℃)',
      pureWaterTds: 'Pure Water TDS',
      moduleTds: 'Module TDS',
      inletFlowMeter: 'Inlet Flow Meter (mL)',
      outletFlowMeter: 'Outlet Flow Meter (mL)',
      temperatureSensorFailure: 'Temperature Sensor Failure',
      objectDetected: 'Object Detected',
      normal: 'Normal',
      abnormal: 'Abnormal',
      waterTankH: 'Water Tank (H)',
      waterTankL: 'Water Tank (L)',
      pressureTankNotFull: 'Pressure Tank Not Full',
      cooler: 'Cooler',
      hydrogenPump: 'Hydrogen Pump',
      waterPump: 'Water Pump',
      circulationPump: 'Circulation Pump',
      inletValve1: 'Inlet Valve 1',
      inletValve2: 'Inlet Valve 2',
      wasteValve: 'Waste Valve',
      magneticMotor: 'Magnetic Motor',
      atmosphereLight: 'Atmosphere Light',
      valveA: 'Valve A',
      valveB: 'Valve B',
      valveC: 'Valve C',
      valveD: 'Valve D',
      valveE: 'Valve E',
      valveF: 'Valve F',
      sterilizationLamp: 'Sterilization Lamp',
      hydrogenModule: 'Hydrogen Module'
    },

    // Customer record data related
    customerRecord: {
      title: 'Single Use Data Query',
      equipmentId: 'Equipment ID',
      enterEquipmentId: 'Please enter equipment ID',
      equipmentIdRequired: 'Equipment ID is required',
      equipmentType: 'Equipment Type',
      allTypes: 'All Types',
      actionType: 'Action Type',
      singleWaterVolume: 'Single Water Volume (ml)',
      operationTime: 'Operation Time',
      iceWater: 'Ice Water',
      normalWater: 'Normal Water',
      water45: '45℃ Water',
      water60: '60℃ Water',
      water75: '75℃ Water',
      water95: '95℃ Water',
      oneClickClean: 'One Click Clean',
      changeFilter: 'Change Filter',
      oneClickEmpty: 'One Click Empty',
      other: 'Other'
    },

    // Active data statistics related
    activeData: {
      title: 'Device Binding Statistics Query',
      equipmentId: 'Equipment ID',
      enterEquipmentId: 'Please enter equipment ID',
      equipmentIdRequired: 'Equipment ID is required',
      equipmentType: 'Equipment Type',
      allTypes: 'All Types',
      exportData: 'Export Data',
      modifyData: 'Modify Data',
      modifyWaterVolume: 'Modify Water Volume',
      activeTime: 'Active Time',
      storeName: 'Store Name',
      userName: 'User Name',
      userPhone: 'User Phone',
      address: 'Address',
      stageWaterVolume: 'Stage Water Volume (ml)',
      totalWaterVolume: 'Total Water Volume (ml)',
      recentDispenseTime: 'Recent Dispense Time',
      recentCleanTime: 'Recent Clean Time',
      usedDays: 'Used Days',
      waterVolumeRequired: 'Stage water volume is required',
      usedDaysRequired: 'Used days is required',
      modifySuccess: 'Modify successful',
      exportSuccess: 'Export successful',
      exportFailed: 'Export failed',
      homeDevice: 'Home Device',
      sharedDevice: 'Shared Device',
      homeFilter: 'Home Filter',
      sharedFilter: 'Shared Filter',
      unknown: 'Unknown'
    },

  // Customer Management
  orgAdmin: {
    customerName: 'Customer Name',
    customerNamePlaceholder: 'Please enter customer name',
    keyword: 'Keyword',
    keywordPlaceholder: 'Please enter keyword',
    type: 'Type',
    status: 'Status',
    allTypes: 'Type (All)',
    allStatus: 'Status (All)',
    agent: 'Agent',
    dealer: 'Dealer',
    official: 'Official',
    valid: 'Valid',
    invalid: 'Invalid',
    deleted: 'Deleted',
    other: 'Other',
    add: 'Add',
    detail: 'Detail',
    edit: 'Edit',
    viewSecret: 'View Secret',
    delete: 'Delete',
    copy: 'Copy',
    addOrg: 'Add Organization',
    editOrg: 'Edit Organization',
    orgName: 'Organization Name',
    orgCode: 'Organization Code',
    address: 'Organization Address',
    contact: 'Contact Person',
    phone: 'Contact Phone',
    orgNumber: 'Organization Number',
    businessLicense: 'Business License URL',
    legalName: 'Legal Person Name',
    legalIdPhoto: 'Legal Person ID Photo',
    legalIdNumber: 'Legal Person ID Number',
    legalPhone: 'Legal Person Phone',
    remark: 'Remark',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    checkTime: 'Check Time',
    deleteTime: 'Delete Time',
    manageId: 'Manage ID',
    secretId: 'Secret ID',
    secretKey: 'Secret Key',
    orgNameRequired: 'Please enter organization name',
    orgCodeRequired: 'Please enter organization code',
    orgTypeRequired: 'Please select organization type',
    statusRequired: 'Please select status',
    deleteConfirm: 'Are you sure to delete?',
    deleteSuccess: 'Delete successful',
    saveSuccess: 'Save successful',
    copySuccess: 'Copy successful',
    copyFailed: 'Copy failed'
  },

  // Agent Review
  agentCheck: {
    title: 'Agent Review',
    orgName: 'Organization Name',
    orgNamePlaceholder: 'Please enter organization name',
    applyStatus: 'Application Status',
    allStatus: 'All Status',
    pending: 'Pending',
    approved: 'Approved',
    rejected: 'Rejected',
    contact: 'Contact',
    phone: 'Phone',
    applyTime: 'Application Time',
    applyReason: 'Application Reason',
    actions: 'Actions',
    audit: 'Audit',
    view: 'View Details',
    auditTitle: 'Agent Review',
    viewTitle: 'Application Details',
    address: 'Address',
    legalName: 'Legal Name',
    legalPhone: 'Legal Phone',
    auditResult: 'Audit Result',
    approve: 'Approve',
    reject: 'Reject',
    auditRemark: 'Audit Remark',
    auditRemarkPlaceholder: 'Please enter audit remark',
    submitAudit: 'Submit Audit',
    auditStatusRequired: 'Please select audit result',
    auditRemarkRequired: 'Please enter audit remark',
    auditSuccess: 'Audit successful',
    auditFailed: 'Audit failed',
    unknown: 'Unknown'
  },

  // Agent Commission Management
  agentCps: {
    title: 'Agent Commission Management',
    recordQuery: 'Commission Record Query',
    statistics: 'Agent Commission Statistics',
    settlement: 'Commission Settlement Management',
    orderId: 'Order ID',
    orderIdPlaceholder: 'Please enter order ID',
    agentId: 'Agent ID',
    agentIdPlaceholder: 'Please enter agent ID',
    status: 'Status',
    allStatus: 'All Status',
    pending: 'Pending',
    settled: 'Settled',
    cancelled: 'Cancelled',
    batchSettle: 'Batch Settle',
    orderNo: 'Order Number',
    agentName: 'Agent',
    libName: 'Organization Type',
    level: 'Level',
    commissionAmount: 'Commission Amount',
    commissionRate: 'Commission Rate(%)',
    orderAmount: 'Order Amount',
    createTime: 'Create Time',
    settle: 'Settle',
    view: 'View',
    startTime: 'Start Time',
    startTimePlaceholder: 'Start Time',
    endTime: 'End Time',
    endTimePlaceholder: 'End Time',
    searchStats: 'Search Statistics',
    commissionStats: 'Commission Statistics',
    commissionTrend: 'Commission Trend',
    totalAmount: 'Total Commission Amount',
    totalRecords: 'Commission Records',
    noStatsData: 'No statistics data',
    trendPlaceholder: 'Trend chart feature to be implemented',
    settleAll: 'Settle All Pending Commissions',
    exportSettle: 'Export Settlement Report',
    settleConfirm: 'Are you sure to settle this commission record?',
    settleSuccess: 'Settlement successful',
    settleFailed: 'Settlement failed',
    selectRecords: 'Please select records to settle first',
    noPendingRecords: 'No pending records',
    batchSettleConfirm: 'Are you sure to batch settle selected commission records?',
    batchSettleSuccess: 'Batch settlement successful',
    batchSettleFailed: 'Batch settlement failed',
    settleAllConfirm: 'Are you sure to settle all pending commission records?',
    settleAllSuccess: 'Settle all successful',
    settleAllFailed: 'Settle all failed',
    exportFeature: 'Export feature to be implemented',
    viewFeature: 'View details feature to be implemented',
    agentIdRequired: 'Please enter agent ID',
    unknown: 'Unknown'
  },

  // Device Debug Page
  equStatus: {
    title: 'Device Debug Page',
    equId: 'Device ID',
    equIdPlaceholder: 'Please enter device ID',
    equIdRequired: 'Device ID is required',
    queryFailed: 'Query Failed',
    hardwareVersion: 'Hardware Version',
    softwareVersion: 'Software Version',
    softwareDate: 'Software Date',
    deviceNumber: 'Device Number',
    heartbeatValue: 'Heartbeat Value',
    status: 'Status',
    fault: 'Fault',
    digitalInput: 'Digital Input',
    digitalOutput: 'Digital Output',
    waterMachineStep: 'Water Machine Step',
    waterMachineStepTimer: 'Water Machine Step Timer',
    outletType: 'Outlet Type',
    outletTargetTemperature: 'Outlet Target Temperature',
    outletTargetFlow: 'Outlet Target Flow',
    outletActualTemperature: 'Outlet Actual Temperature',
    outletActualFlow: 'Outlet Actual Flow',
    waterMakingStep: 'Water Making Step',
    waterMakingStepTimer: 'Water Making Step Timer (seconds)',
    waterShortageStep: 'Water Shortage Step',
    waterShortageStepTimer: 'Water Shortage Step Timer (seconds)',
    lightBarStep: 'Light Bar Step',
    lightBarStepTimer: 'Light Bar Step Timer (seconds)',
    instantHeatStep: 'Instant Heat Step',
    instantHeatInletTemperature: 'Instant Heat Inlet Temperature',
    instantHeatOutletTemperature: 'Instant Heat Outlet Temperature',
    instantHeatOutflow: 'Instant Heat Outflow',
    instantHeatFailureCount: 'Instant Heat Failure Count',
    instantHeatHeating: 'Instant Heat Heating (0: No, 1: Yes)',
    instantHeatFaultCode: 'Instant Heat Fault Code',
    hydrogenRichModuleStep: 'Hydrogen Rich Module Step',
    hydrogenRichModuleStepTimer: 'Hydrogen Rich Module Step Timer (seconds)',
    autoClean24HTimer: '24H Auto Clean Timer (seconds)',
    autoClean20LCountdownLiters: '20L Auto Clean Countdown Liters',
    ionFilterCleanRemainingTime1: 'Ion Filter Clean Remaining Time 1 (seconds)',
    ionFilterCleanRemainingTime2: 'Ion Filter Clean Remaining Time 2 (seconds)',
    ionFilterCleanRemainingTime3: 'Ion Filter Clean Remaining Time 3 (seconds)',
    filterModuleStep: 'Filter Module Step',
    filterModuleStepTimer: 'Filter Module Step Timer (seconds)',
    filterCleanRemainingTime: 'Filter Clean Remaining Time (seconds)',
    // Additional field translations
    interactionModuleVolume: 'Interaction Module Volume',
    cupRecognitionModuleId: 'Cup Recognition Module ID',
    reserved: 'Reserved',
    bop1: 'BOP1',
    bop2: 'BOP2',
    bop1Error: 'BOP1Error',
    bop2Error: 'BOP2Error',
    bc12Current: 'BC12 Current',
    bc34Current: 'BC34 Current',
    scG1Current: 'SC_G1 Current',
    scG2Current: 'SC_G2 Current',
    referenceVoltage: 'Reference Voltage',
    ntc1: 'ntc1',
    ntc2: 'ntc2',
    onboardTemperatureSensor: 'Onboard Temperature Sensor',
    roPureWaterTds: 'RO Pure Water TDS',
    hydrogenRichModuleTds: 'Hydrogen Rich Module TDS',
    supplyVoltage: 'Supply Voltage',
    inletFlowMeterFrequency: 'Inlet Flow Meter Frequency',
    inletFlow: 'Inlet Flow',
    inletAccumulatedVolume: 'Inlet Accumulated Volume',
    outletFlowMeterFrequency: 'Outlet Flow Meter Frequency',
    outletFlow: 'Outlet Flow',
    outletAccumulatedVolume: 'Outlet Accumulated Volume',
    filterUsageDuration: 'Filter Usage Duration (seconds)',
    filterUsageLiters: 'Filter Usage Liters',
    utc8Time: 'UTC+8 Time',
    simCardNumber1: 'SIM Card Number 1',
    simCardNumber2: 'SIM Card Number 2',
    simCardNumber3: 'SIM Card Number 3',
    // Additional missing field translations
    outletTargetDuration: 'Outlet Target Duration',
    outletCurrentTemperature: 'Outlet Current Temperature',
    outletCurrentFlow: 'Outlet Current Flow',
    outletCurrentDuration: 'Outlet Current Duration',
    humanDistance: 'Human Distance',
    interactionModuleCommand: 'Interaction Module Command',
    simCardNumber4: 'SIM Card Number 4',
    simCardNumber5: 'SIM Card Number 5',
    fourGSignalStrength: '4G Signal Strength',
    cellInfo1: 'Cell Info MNC',
    cellInfo2: 'Cell Info CID',
    cellInfo3: 'Cell Info LAC',
    fourGStep: '4G Step',
    // Additional missing field translations
    fourGStepTimer: '4G Step Timer (seconds)',
    mqttStep: 'MQTT Step',
    mqttStepTimer: 'MQTT Step Timer (seconds)',
    mqttPublishStep: 'MQTT Publish Step',
    mqttPublishStepTimer: 'MQTT Publish Timer (seconds)',
    reservedField1: 'Reserved Field 1',
    reservedField2: 'Reserved Field 2',
    reservedField3: 'Reserved Field 3',
    reservedField4: 'Reserved Field 4',
    httpStep: 'HTTP Step',
    httpStepTimer: 'HTTP Step Timer (seconds)',
    outletStep: 'Outlet Step',
    outletStepTimer: 'Outlet Step Timer (seconds)',
    normalWaterStep: 'Normal Water Step',
    normalWaterStepTimer: 'Normal Water Step Timer (seconds)',
    normalWaterOutflow: 'Normal Water Outflow',
    normalWaterOutflowTimer: 'Normal Water Outflow Timer (seconds)',
    hotWaterStep: 'Hot Water Step',
    hotWaterStepTimer: 'Hot Water Step Timer (seconds)',
    hotWaterOutflow: 'Hot Water Outflow',
    hotWaterOutflowTimer: 'Hot Water Outflow Timer (seconds)'
  },

  // MQTT Water Record Query
  statusDetail: {
    title: 'MQTT Order Data Query',
    equId: 'Device ID',
    equIdPlaceholder: 'Please enter device ID',
    equIdRequired: 'Device ID is required',
    requestId: 'Water Record ID',
    operaTime: 'Create Time',
    type: 'Water Type',
    bagful: 'Order Bags',
    volumn: 'Volume per Bag·ml',
    outwaterTime: 'Water Time',
    bagfulOD: 'Actual Bags',
    volumnTTLOD: 'Total Volume·ml',
    closewaterTime: 'End Time',
    status: 'Order Status',
    waterDetail: 'Water Detail',
    queryFailed: 'Query Failed',
    detailFailed: 'Get Detail Failed',
    iceWater: 'Ice Water',
    normalWater: 'Normal Water',
    warmWater45: '45℃ Water',
    warmWater75: '75℃ Water',
    hotWater95: '95℃ Water',
    other: 'Other',
    created: 'Order Created',
    watering: 'Watering',
    completed: 'Completed',
    abnormalClose: 'Abnormal Close',
    detailRequestId: 'Order Number',
    detailBagful: 'Bag Number',
    detailVolumn: 'Volume per Bag·ml',
    volumnOD: 'Actual Volume·ml',
    usedTimeOD: 'Used Time·sec',
    detailClosewaterTime: 'Complete Time'
  },

  // MQTT Device Status Query
  statusAdmin: {
    title: 'MQTT Device Status Query',
    equId: 'Device ID',
    equIdPlaceholder: 'Please enter device ID',
    equIdRequired: 'Please enter device ID',
    onLineStatus: 'Online Status',
    heartbitStatus: 'Machine Status',
    digitalInput: 'Digital Input',
    digitalOutput: 'Digital Output',
    waterMachineStep: 'Water Machine Step',
    errStatus: 'Error Code',
    active: 'Activation Time',
    volumn: 'Usage Volume·ml',
    waterRecord: 'Water Record',
    filterRecord: 'Filter Record',
    deviceDetail: 'Device Detail',
    online: 'Device Online',
    offline: 'Device Offline',
    notActivated: 'Device Not Activated',
    noInput: 'No Input',
    noOutput: 'No Output',
    none: 'None',
    queryFailed: 'Query Failed',
    orgName: 'Organization Name',
    orgCode: 'Organization Code',
    orgType: 'Type',
    status: 'Status',
    orgAddress: 'Organization Address',
    orgLinkName: 'Organization Contact',
    orgLinkPhone: 'Organization Phone',
    orgNumber: 'Organization Number',
    orgUrl: 'Business License URL',
    orgOwner: 'Legal Name',
    orgOwnerUrl: 'Legal ID Photo',
    orgOwnerID: 'Legal ID Number',
    orgOwnerPhone: 'Legal Phone',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    checkTime: 'Check Time',
    deleteTime: 'Delete Time',
    remark: 'Remark',
    official: 'Official',
    agent: 'Agent',
    dealer: 'Dealer',
    valid: 'Valid',
    invalid: 'Invalid',
    deleted: 'Deleted'
  },

  // Route Configuration
  routeConfig: {
    routeManagement: 'Route Management',
    configSettings: 'Configuration Settings',
    recordQuery: 'Commission Record Query',
    routeName: 'Route Name',
    routeNamePlaceholder: 'Please enter route name',
    routeCode: 'Route Code',
    routeCodePlaceholder: 'Please enter route code',
    description: 'Description',
    descriptionPlaceholder: 'Please enter description',
    status: 'Status',
    allStatus: 'All Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    configCount: 'Config Count',
    createTime: 'Create Time',
    addRoute: 'Add Route',
    edit: 'Edit',
    config: 'Config',
    enable: 'Enable',
    disable: 'Disable',
    delete: 'Delete',
    selectRoute: 'Select Route',
    selectRoutePlaceholder: 'Please select route',
    loadConfig: 'Load Config',
    saveConfig: 'Save Config',
    addConfig: 'Add Config',
    libName: 'Organization Type',
    level: 'Level',
    levelPlaceholder: 'Please enter level (1-10)',
    commissionRate: 'Commission Rate(%)',
    commissionRatePlaceholder: 'Please enter commission rate',
    minAmount: 'Min Amount',
    minAmountPlaceholder: 'Please enter min amount',
    maxAmount: 'Max Amount',
    maxAmountPlaceholder: 'Please enter max amount',
    orderId: 'Order ID',
    orderIdPlaceholder: 'Please enter order ID',
    agentId: 'Agent ID',
    agentIdPlaceholder: 'Please enter agent ID',
    pending: 'Pending',
    settled: 'Settled',
    cancelled: 'Cancelled',
    orderNo: 'Order Number',
    agentName: 'Agent',
    commissionAmount: 'Commission Amount',
    orderAmount: 'Order Amount',
    settle: 'Settle',
    view: 'View',
    editRoute: 'Edit Route',
    editConfig: 'Edit Config',
    selectLibPlaceholder: 'Please select organization type',
    toggleStatusConfirm: 'Are you sure to {action} this route?',
    statusUpdateSuccess: 'Status updated successfully',
    statusUpdateFailed: 'Status update failed',
    deleteConfirm: 'Are you sure to delete? This action cannot be undone!',
    deleteSuccess: 'Delete successful',
    deleteFailed: 'Delete failed',
    saveSuccess: 'Save successful',
    saveFailed: 'Save failed',
    selectRouteFirst: 'Please select route first',
    batchSaveFeature: 'Batch save config feature to be implemented',
    settleConfirm: 'Are you sure to settle this commission record?',
    settleSuccess: 'Settlement successful',
    settleFailed: 'Settlement failed',
    viewFeature: 'View details feature to be implemented',
    routeNameRequired: 'Route name is required',
    routeCodeRequired: 'Route code is required',
    libIdRequired: 'Organization type is required',
    levelRequired: 'Level is required',
    commissionRateRequired: 'Commission rate is required',
    unknown: 'Unknown'
  },

  // Admin Account Management
  equUser: {
    title: 'Admin Account Management',
    userName: 'User Account',
    userNamePlaceholder: 'Please enter user account',
    userNameRequired: 'User account is required',
    status: 'Status',
    statusPlaceholder: 'Please select status',
    statusRequired: 'Status is required',
    allStatus: 'All',
    normal: 'Normal',
    disabled: 'Disabled',
    unknown: 'Unknown',
    isSuperAdmin: 'Super Admin',
    userType: 'User Type',
    userTypeRequired: 'User type is required',
    superAdmin: 'Super Admin',
    normalUser: 'Normal User',
    yes: 'Yes',
    no: 'No',
    remark: 'Remark',
    remarkPlaceholder: 'Please enter remark',
    addUser: 'Add Account',
    editUser: 'Edit User',
    resetPassword: 'Reset Password',
    resetPasswordConfirm: 'Reset password to: 123456?',
    resetPasswordSuccess: 'Password reset successfully',
    resetPasswordFailed: 'Password reset failed',
    permissionControl: 'Permission Control',
    defaultPassword: 'Password: Default 123456',
    getUserListFailed: 'Failed to get user list',
    getPermissionsFailed: 'Failed to get user permissions',
    saveSuccess: 'Save successfully',
    saveFailed: 'Save failed',
    savePermissionsSuccess: 'Permissions saved successfully',
    savePermissionsFailed: 'Failed to save permissions'
  }
}
